// extracted by mini-css-extract-plugin
module.exports = {"alumniHeader":"alumniLogoHeader_alumniHeader__ibu0C"};